// removed by extract-text-webpack-plugin
module.exports = {"table":"CwTable-table","tableAlternateRow":"CwTable-tableAlternateRow","nested":"CwTable-nested"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwtable/CwTable.scss
// module id = 391
// module chunks = 0